new Splide( '.splie-id-2', {
		type: 'loop', 
	  	rewind: true,
	  	perPage: number = 1.5, 
	  	start: number = 1,
	  	focus: 'center', 
	  	padding: { left: "10%", right: "9%" }, 
	  	drag: 'free', 
	  	snap   : false,
	  	flickPower: 500, 
	  	updateOnMove: true,
	  	fixedWidth: '14.5rem',
	  	fixedHeight: 'auto', 
	  	gap: '8rem', 
	  	heightRatio : 0.8,
	  	pagination: false,
        arrows: false,
	  	mediaQuery: 'min',
		  breakpoints: {
				800: {
					fixedWidth: '16.5rem',
				},
				890: {
					fixedWidth: '16.5rem',
				},
                756: { 
					arrows: true,
				},
		  }
	  } ).mount();